// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__8fuVK","icon":"Loading_icon__XAFEo"};